// extracted by mini-css-extract-plugin
export default {"wrapper":"RulesPage_wrapper__215QM"};